import { ReactElement, useEffect, useState } from 'react'
import { ContextProps, createContext } from '../utils/contextHelper'
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr'

interface SignalRContextState {
  signalRConnection: HubConnection | null
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
const [Provider, useSignalRContext] = createContext<SignalRContextState>(module.filename)

export { useSignalRContext }

async function joinManagerClients(connection: HubConnection): Promise<void> {
  try {
    await connection.invoke('JoinManagerClients')
  } catch (error) {
    // Backend may be momentarily unavailable or an older build without this hub method.
    // eslint-disable-next-line no-console
    console.error('Failed to join ManagerClients SignalR group', error)
  }
}

export function SignalRProvider({ children }: ContextProps): ReactElement {
  const [signalRConnection, setSignalRConnection] = useState<HubConnection | null>(null)

  useEffect(() => {
    const newConnection = new HubConnectionBuilder()
      .withUrl(`${API_BASE_URL}/hubs/printAgent`, { withCredentials: true })
      .withAutomaticReconnect()
      .build()

    newConnection.onreconnected(() => {
      void joinManagerClients(newConnection)
    })

    newConnection.start().then(async () => {
      await joinManagerClients(newConnection)
      setSignalRConnection(newConnection)
    })

    return () => {
      newConnection.stop()
    }
  }, [])

  return <Provider value={{ signalRConnection: signalRConnection }}>{children}</Provider>
}
